import { Separator } from '@workspace/ui/components/separator'
import type { ActivityEntry } from '../types'
import { ActivityRow } from './activity-row'

export function DateGroup({ date, entries }: { date: string; entries: ActivityEntry[] }) {
  return (
    <section>
      <div className="mb-2 flex items-center gap-3">
        <span className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/80">
          {date}
        </span>
        <Separator className="flex-1" />
      </div>
      <div className="overflow-hidden rounded-xl border border-border bg-card/30">
        <div className="divide-y divide-border">
          {entries.map((entry) => (
            <ActivityRow key={entry.id} entry={entry} />
          ))}
        </div>
      </div>
    </section>
  )
}
